<template>
    <ValidationObserver ref="observer">
        <div>
            <!-- first card starts -->
            <b-card>
                <b-row class="align-items-start">
                    <b-col cols="12" md="3" class="mb-3 mb-md-0">
                        <div class="tenantProfile_img">
                            <single-image
                                class="profile-img"
                                height="120px"
                                width="120px"
                                :no-padding="true"
                                @change="(d) => uploadImage('profilePhoto', d)"
                                :id="'profilePhoto'"
                                ref="profilePhoto"
                                :url="userInfo.profilePhoto"
                                label="Browse Profile Photo"
                            ></single-image>
                            <span
                                v-if="userInfo && userInfo.unsuppprtedFile"
                                class="validate-error"
                                >Unsupported file format! Please select an
                                image</span
                            >
                        </div>
                    </b-col>

                    <b-col cols="12" md="4">
                        <!-- Second Column -->
                        <b-row>
                            <b-col>
                                <ValidationProvider
                                    rules="required|alpha_spaces"
                                    v-slot="{ errors }"
                                    name="First Name"
                                >
                                    <c-input
                                        inputType="text"
                                        inputId="FirstName"
                                        labelText="First Name *"
                                        v-model="userinfo.first"
                                        class="mb-4 mt-2"
                                    />
                                    <span class="validate-error custm-err">{{
                                        errors[0]
                                    }}</span>
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <ValidationProvider
                                    rules="required|alpha_spaces"
                                    v-slot="{ errors }"
                                    name="Last Name"
                                >
                                    <c-input
                                        inputType="text"
                                        inputId="LastName"
                                        labelText="Last Name *"
                                        v-model="userinfo.last"
                                        class="mb-4 mt-2"
                                    />
                                    <span class="validate-error custm-err">{{
                                        errors[0]
                                    }}</span>
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" md="5">
                        <!-- Third Column -->
                        <b-row>
                            <b-col>
                                <ValidationProvider
                                    rules="required|email|no-capital-first-letter"
                                    v-slot="{ errors }"
                                    name="Email"
                                >
                                    <c-input
                                        inputType="text"
                                        inputId="Email"
                                        labelText="Email *"
                                        v-model="userinfo.email"
                                        class="mt-2 mb-2"
                                    />
                                    <span
                                        v-if="errors[0]"
                                        class="validate-error custm-err"
                                        >{{ errors[0] }} (First letter should be
                                        small)</span
                                    >
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <ValidationProvider
                                    rules="required|max:15|min:10"
                                    v-slot="{ errors }"
                                    name="Phone no"
                                >
                                    <c-tel-input
                                        v-model="userinfo.phone"
                                        class="m-0 mb-2 mt-4"
                                    />
                                    <span class="validate-error custm-err">{{
                                        errors[0]
                                    }}</span>
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </b-card>

            <!-- end of first card -->
            <b-card>
                <div class="heading">More Details</div>
                <b-row class="mt-1">
                    <b-col md="6">
                        <ValidationProvider
                            rules="required"
                            v-slot="{ errors }"
                            name="Education"
                        >
                            <label></label>
                            <c-input
                                inputType="text"
                                inputId="Education"
                                labelText="Education *"
                                v-model="userinfo.education"
                            ></c-input>
                            <span class="validate-error custm-err">{{
                                errors[0]
                            }}</span>
                        </ValidationProvider>
                    </b-col>
                    <b-col md="6">
                        <label></label>
                        <ValidationProvider
                            rules="required"
                            v-slot="{ errors }"
                            name="Working Experience"
                        >
                            <c-input
                                inputType="number"
                                inputId="Experience"
                                labelText="Working Experience *"
                                v-model="userinfo.value"
                            />
                            <span class="validate-error custm-err">{{
                                errors[0]
                            }}</span>
                        </ValidationProvider>
                    </b-col>
                    <b-col md="6">
                        <label for="UOM">UOM</label>
                        <ValidationProvider
                            rules="required"
                            v-slot="{ errors }"
                            name="UOM"
                        >
                            <eb-select
                                type="text"
                                v-model="userinfo.uom"
                                :options="['Days', 'Months', 'Years']"
                                label="label"
                                placeholder="UOM *"
                            ></eb-select>
                            <span class="validate-error custm-err">{{
                                errors[0]
                            }}</span>
                        </ValidationProvider>
                    </b-col>

                    <b-col md="6">
                        <label for="DOB">DOB</label>
                        <ValidationProvider
                            rules="required|futureDate"
                            v-slot="{ errors }"
                            name="DOB"
                        >
                            <b-input
                                id="activation-date"
                                type="date"
                                v-model="userinfo.dob"
                            ></b-input>
                            <span class="validate-error custm-err">{{
                                errors[0]
                            }}</span>
                        </ValidationProvider>
                    </b-col>
                    <b-col md="6">
                        <label for="Gender">Gender</label>
                        <ValidationProvider
                            rules="required"
                            v-slot="{ errors }"
                            name="Gender"
                        >
                            <eb-select
                                type="text"
                                v-model="userinfo.gender"
                                :options="['Female', 'Male', 'Others']"
                                label="label"
                                placeholder="Gender *"
                            ></eb-select>
                            <span class="validate-error custm-err">{{
                                errors[0]
                            }}</span>
                        </ValidationProvider>
                    </b-col>
                    <b-col md="6">
                        <ValidationProvider
                            rules="required"
                            v-slot="{ errors }"
                            name="Marital Status"
                        >
                            <label for="Marital Status">Marital Status</label>
                            <eb-select
                                type="text"
                                v-model="userinfo.maritalStatus"
                                :options="['Single', 'Married']"
                                label="label"
                                placeholder="Marital Status *"
                            ></eb-select>
                            <span class="validate-error custm-err">{{
                                errors[0]
                            }}</span>
                        </ValidationProvider>
                    </b-col>
                    <b-col md="12">
                        <label></label>
                        <ValidationProvider
                            rules="required"
                            v-slot="{ errors }"
                            name="About Me"
                        >
                            <c-input
                                inputType="text"
                                inputId="AboutMe"
                                labelText="About Me *"
                                v-model="userinfo.aboutMe"
                            />
                            <span class="validate-error custm-err">{{
                                errors[0]
                            }}</span>
                        </ValidationProvider>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <DynamicInput
                            :fields="externalInfoUser || []"
                            :visibility="isVisible"
                            ref="dynamicForm"
                            @update:formData="handleExtendedAttributesUpdate"
                        />
                    </b-col>
                </b-row>
                <slot
                    name="footer-button"
                    :data="{ userinfo, extendedAttributes }"
                ></slot>
            </b-card>
        </div>
    </ValidationObserver>
</template>
<script>
import {
    ValidationProvider,
    ValidationObserver,
    Validator,
} from "vee-validate";
import cInput from "@/components/FormElements/CustomInput";
import cTelInput from "@/components/FormElements/MobileNumberInput";
import ebSelect from "@/components/FormElements/Select";
import SingleImage from "@/components/Common/Image.vue";
import Vue from "vue";
import moment from "moment";
import DynamicInput from "@/components/Partner/additionalInfo.vue";
import { mapState } from "vuex";
export default {
    name: "userinfoStepper",
    props: {
        userInfo: {
            type: Object,
            required: false,
            default: () => ({
                firstName: "",
                lastName: "",
                value: "",
                uom: "",
                dob: "",
                gender: "",
                profilePhoto: "",
                authentication: {
                    email: "",
                    phone: "",
                },
                unsuppprtedFile: false,
                maritalStatus: "",
                education: "",
                aboutMe: "",
            }),
        },
    },
    data() {
        return {
            extendedAttributes: {},
            externalInfoUser: [],
            userinfo: {
                first: "",
                last: "",
                email: "",
                phone: "",
                value: "",
                uom: "",
                gender: "",
                dob: "",
                profilePhoto: "",
                maritalStatus: "",
                education: "",
                aboutMe: "",
            },
        };
    },
    components: {
        DynamicInput,
        cInput,
        cTelInput,
        ebSelect,
        SingleImage,
        ValidationObserver,
        ValidationProvider,
    },
    computed: {
        ...mapState({
            extendedList: (state) => state.tenant.extendedList,
        }),
        isVisible() {
            return this.externalInfoUser && this.externalInfoUser.length >= 0;
        },
    },
    watch: {
        // keep local userinfo updated when parent sends new data
        userInfo: {
            deep: true,
            immediate: true,
            handler(newVal) {
                this.userinfo = {
                    first: newVal.firstName || "",
                    last: newVal.lastName || "",
                    email: newVal.authentication?.email || "",
                    phone: newVal.authentication?.phone || "",
                    dob: newVal.dob || "",
                    value: newVal.value || "",
                    uom: newVal.uom || "",
                    gender: newVal.gender || "",
                    profilePhoto: newVal.profilePhoto || "",
                    maritalStatus: newVal.maritalStatus || "",
                    education: newVal.education || "",
                    aboutMe: newVal.aboutMe || "",
                };
            },
        },
        // push local edits back to parent
        userinfo: {
            deep: true,
            handler(updated) {
                this.$emit("update:userInfo", {
                    firstName: updated.first,
                    lastName: updated.last,
                    authentication: {
                        email: updated.email,
                        phone: updated.phone,
                    },
                    dob: updated.dob,
                    value: updated.value,
                    uom: updated.uom,
                    gender: updated.gender,
                    profilePhoto: updated.profilePhoto,
                    maritalStatus: updated.maritalStatus,
                    education: updated.education,
                    aboutMe: updated.aboutMe,
                });
            },
        },
    },
    methods: {
        handleExtendedAttributesUpdate(updatedData) {
            this.extendedAttributes = updatedData;
        },
        async getAttributeList() {
            this.$store.dispatch("tenant/setExtendedAttributeList").then(() => {
                this.externalInfoUser = this.extendedList.externalInfoAdmin || [];
            });
        },
        showCustomToast() {
            Vue.toasted.show("Uploading...", {
                type: "info",
                theme: "toasted-primary",
                singleton: true,
                duration: 1000000,
            });
        },
        clearCustomToast() {
            Vue.toasted.clear();
        },
        isValid() {
            const isValid = this.$refs.observer.validate();
            this.$emit("isValid", isValid);
            return isValid;
        },
        async uploadImage(path, image) {
            if (!image.includes("data:image")) {
                this.userinfo[path] = null;
                this.userInfo.unsuppprtedFile = true;

                return;
            }
            this.userInfo.unsuppprtedFile = false;

            let dataobj = {
                image: image,
                key: (
                    Date.now().toString(36) +
                    Math.random().toString(36).substr(2, 5)
                ).toLowerCase(),
                isPublic: true,
                replaceExisting: true,
                basePath: ["agent", "profilePhoto"],
            };
            this.showCustomToast();
            await this.$store
                .dispatch("inventory/uploadImageToStorage", dataobj)
                .then((res) => {
                    this.clearCustomToast();
                    this.userinfo[path] = res.data.fileUrl;
                })
                .catch((error) => {
                    this.clearCustomToast();
                    this.$toasted.error(
                        "Image not uploaded..please try again!",
                    );
                });
        },
    },
    mounted() {
        this.getAttributeList();
        this.today = moment().format("DD-MM-yyyy");
        Validator.extend(
            "futureDate",
            (value, [otherValue]) => {
                return moment().diff(value, "day") >= 1;
            },
            {
                hasTarget: true,
            },
        );
        Validator.extend("no-capital-first-letter", {
            validate(value) {
                return value[0] !== value[0].toUpperCase();
            },
        });
    },
};
</script>
<style scoped>
.location-search {
    border-radius: 0rem;
    color: rgb(0, 0, 0);
    box-shadow: none !important;
    font-family: "Lato";
    height: 39px !important;
    border: 1px solid #dee2e6;
    padding-left: 10px;
    width: 100%;
    font-size: small;
}

[btn-color="primary"] {
    height: 41px;
    background-color: var(--primary);
    font-weight: 600;
    font-size: medium;
    letter-spacing: 2px;
    font-family: "Lato";
    color: white;
    border: 0px;
    border-radius: 0px;
}

[btn-special="primary"] {
    border: 0px;
    font-weight: 500;
    letter-spacing: 1px;
    font-size: medium;
    font-family: "Lato";
    border-radius: 0px;
    height: 43px;
    width: 139px;
    background-color: var(--primary);
    color: white;
}


.tenantProfile_img {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    position: relative;
    overflow: hidden;
    border: 2px solid #4645e7;
    margin: 0 auto;
    margin-top: 5px;
    padding: 0 !important;
    display: block;
    line-height: 0;
    font-size: 0;
}
.profile-img {
    margin: 0 !important;
    padding: 0 !important;
    height: 120px !important;
    width: 120px !important;
    border: none !important;
    border-radius: 50% !important;
    display: block !important;
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    overflow: hidden !important;
}
.profile-img >>> .image_wrap {
    padding: 0 !important;
    border: none !important;
    height: 120px !important;
    width: 120px !important;
    border-radius: 50% !important;
    overflow: hidden !important;
    margin: 0 !important;
    box-sizing: border-box !important;
    line-height: 0 !important;
    font-size: 0 !important;
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
}
.profile-img >>> .image_wrap > div {
    height: 100% !important;
    width: 100% !important;
    border-radius: 50% !important;
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    padding: 0 !important;
    margin: 0 !important;
    line-height: 0 !important;
    font-size: 0 !important;
}
.profile-img >>> .image_wrap img {
    width: 120px !important;
    height: 120px !important;
    min-width: 120px !important;
    min-height: 120px !important;
    max-width: none !important;
    max-height: none !important;
    object-fit: cover !important;
    object-position: center !important;
    border-radius: 50% !important;
    position: absolute !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-52%, -52%) scale(1.12) !important;
    margin: 0 !important;
    padding: 0 !important;
    border: none !important;
    outline: none !important;
    display: block !important;
    line-height: 0 !important;
    font-size: 0 !important;
}

@media (max-width: 767.98px) {
    .profile-img {
        height: 120px !important;
        width: 120px !important;
    }
}
.heading {
    font-size: 18px;
    font-weight: 700;
    color: #000000;
}
.custm-err {
    color: red;
}
</style>
<style>
/* Non-scoped styles to ensure image fills circle - higher specificity */
.tenantProfile_img .profile-img,
.tenantProfile_img .profile-img * {
    box-sizing: border-box !important;
}
.tenantProfile_img .profile-img .image_wrap {
    padding: 0 !important;
    border: none !important;
    height: 120px !important;
    width: 120px !important;
    border-radius: 50% !important;
    overflow: hidden !important;
    margin: 0 !important;
    box-sizing: border-box !important;
    line-height: 0 !important;
    font-size: 0 !important;
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
}
.tenantProfile_img .profile-img .image_wrap > div {
    height: 100% !important;
    width: 100% !important;
    border-radius: 50% !important;
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    padding: 0 !important;
    margin: 0 !important;
    box-sizing: border-box !important;
    line-height: 0 !important;
    font-size: 0 !important;
}
.tenantProfile_img .profile-img .image_wrap img {
    width: 120px !important;
    height: 120px !important;
    min-width: 120px !important;
    min-height: 120px !important;
    max-width: none !important;
    max-height: none !important;
    object-fit: cover !important;
    object-position: center !important;
    border-radius: 50% !important;
    position: absolute !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-52%, -52%) scale(1.12) !important;
    margin: 0 !important;
    padding: 0 !important;
    border: none !important;
    outline: none !important;
    display: block !important;
    line-height: 0 !important;
    font-size: 0 !important;
}
</style>
